import React from 'react'

export default function AddShopCds() {
  return (
    <div>Add Shop Passed</div>
  )
}
